import {rootState} from '@mintdata-wsp/common/state/RootState';
import {GridMeasureRequest} from '@mintdata-wsp/common/state/ui/visualDesigner/grid/GridMeasure';
import {IMeasureBag} from '@mintdata-wsp/common/state/ui/visualDesigner/grid/GridModel';
import {action} from 'mobx';

export class GridMeasureController
{
    @action.bound
    public measure(request:GridMeasureRequest):void
    {
        const requests = rootState.ui.visualDesigner.gridMeasure.measureRequests;
        const origMeasureDone = request.onMeasureDone;

        request.onMeasureDone = action((bag:IMeasureBag) =>
        {
            const idx = requests.findIndex((r:GridMeasureRequest) => (r.id === request.id));
            requests.splice(idx, 1);

            origMeasureDone(bag);
        });

        requests.push(request);
    }
}
